import React from "react";
import "./Catalog.scss";

import Medicine from "./Medicine/Medicine";
import MedicineType from "./MedicineType/MedicineType";
import MedicineGroup from "./MedicineGroup/MedicineGroup";
import Store from "./Store/Store";
import StoreOfUser from "./StoreOfUser/StoreOfUser";
import ActiveSubstance from "./ActiveSubstance/ActiveSubstance";
import Supplier from "./Supplier/Supplier";
import BiddingDecision from "./BiddingDecision/BiddingDecision";

const Catalog = () => {
  return (
    <div className="catalog">
      <StoreOfUser></StoreOfUser>
      <Store></Store>
      <Medicine></Medicine>
      <MedicineType></MedicineType>
      <MedicineGroup></MedicineGroup>
      <ActiveSubstance></ActiveSubstance>
      <Supplier></Supplier>
      <BiddingDecision />
    </div>
  );
};
export default Catalog;
